import React, { Component } from 'react';
import PropTypes from 'prop-types';
import FormattedTime from '../FormattedTime';
import { isInAppWebView } from '../../utils/deviceUtil';
import openWithAppTalk from '../../utils/openWithAppTalk';

export default class PortalCouponListItem extends Component {
  constructor(props) {
    super(props);
    this.getDDay = this.getDDay.bind(this);
    this.handleClickCoupon = this.handleClickCoupon.bind(this);
    this.renderDimmedItem = this.renderDimmedItem.bind(this);
    this.renderItem = this.renderItem.bind(this);
    this.callbackReceiveCoupon = this.callbackReceiveCoupon.bind(this);
    this.callbackReloadReceivedCoupon = this.callbackReloadReceivedCoupon.bind(this);
  }

  getDDay(entryEndAt) {
    const result = entryEndAt - (new Date());
    return Math.floor(result / (86400 * 1000))
  }

  handleClickCoupon(e) {
    if (e) {
      e.preventDefault();
    }
    const { device, coupon, handleReceiveCoupon, handleReloadReceivedCoupon } = this.props;
    const profileId = coupon.get('profileId');
    const couponId = coupon.get('id');

    if (!isInAppWebView(device)) {
      alert('카카오톡 모바일앱에서 가능합니다.');
      return;
    }

    if (handleReceiveCoupon) {
      window.callbackReceiveCoupon = this.callbackReceiveCoupon;
    }
    if (handleReloadReceivedCoupon) {
      window.callbackReloadReceivedCoupon = this.callbackReloadReceivedCoupon;
    }

    openWithAppTalk(device, `plusfriend/coupon/${profileId}/${couponId}?from=pf_portal`);
  }

  callbackReceiveCoupon() {
    const { index, coupon } = this.props;
    this.props.handleReceiveCoupon(index, coupon.get('id'));
  }

  callbackReloadReceivedCoupon() {
    this.props.handleReloadReceivedCoupon();
  }

  renderItem() {
    const { index, coupon, isReceived } = this.props;
    const profileId = coupon.get('profileId');
    const couponId = coupon.get('id');
    const title = coupon.get('title', '');
    return (
      <a
        href="#clickCoupon"
        className="link_coupon" 
        onClick={(e) => {this.handleClickCoupon(e);}}
        data-tiara-id={couponId} data-tiara-type="couponId" data-tiara-name={title} data-tiara-ordnum={index}
        data-tiara-click_url={`plusfriend/coupon/${profileId}/${couponId}`}
        data-tiara-layer="coupon_item"
      >
        <div className="item_coupon" role="text">
          <div className="coupon_thumb">
            <img src={coupon.getIn(['entryImage','mediumUrl'])} width={70} height={70} className="thumb_g" alt="" />
            <em className="badge_valid">
              {isReceived && (this.getDDay(coupon.get('usedEndAt')) === 0 ? '오늘' : `D-${this.getDDay(coupon.get('usedEndAt'))}`)}
              {(!isReceived) && (this.getDDay(coupon.get('entryEndAt')) === 0 ? '오늘' : `D-${this.getDDay(coupon.get('entryEndAt'))}`)}
            </em>
          </div>
          <div className="info_thumb">
            <div className="innner_info">
              <strong className="tit_subject">{coupon.getIn(['author','nickname'])}</strong>
              <span className="txt_story">{title}</span>
            </div>
          </div>
          {(!isReceived) && (<span className="ico_plus ico_download">다운로드</span>)}
        </div>
          {isReceived && (<p className="txt_valid">유효기간 : <FormattedTime value={coupon.get('usedEndAt')} tz="Asia/Seoul"/> 까지</p>)}
          {(!isReceived) && (<p className="txt_valid">응모기간 : <FormattedTime value={coupon.get('entryStartAt')} tz="Asia/Seoul"/>
            &nbsp;~ <FormattedTime value={coupon.get('entryEndAt')} tz="Asia/Seoul"/></p>)}
      </a>
    );
  }

  renderDimmedItem() {
    const { coupon, isUsed, isExpired } = this.props;
    return (
      <div className="link_coupon">
        <div className="item_coupon" role="text">
          <div className="coupon_thumb">
            <img src={coupon.getIn(['entryImage','mediumUrl'])} width={70} height={70} className="thumb_g" alt="" />
            <em className="badge_valid">
              {isUsed && '사용완료'}
              {isExpired && '기간만료'}
            </em>
          </div>
          <div className="info_thumb">
            <div className="innner_info">
              <strong className="tit_subject">{coupon.getIn(['author','nickname'])}</strong>
              <span className="txt_story">{coupon.get('title')}</span>
            </div>
          </div>
        </div>
        {isExpired && (<p className="txt_valid">기간만료일 : <FormattedTime value={coupon.get('usedEndAt')} tz="Asia/Seoul"/> 까지</p>)}
        {isUsed && (<p className="txt_valid">사용완료일 : <FormattedTime value={coupon.get('usedAt')} tz="Asia/Seoul"/></p>)}
      </div>
    );
  }

  render () {
    const { isUsed, isExpired } = this.props;
    return (
      <li>
        {(isUsed || isExpired) ? this.renderDimmedItem() : this.renderItem()}
      </li>
    );
  }
}

PortalCouponListItem.propTypes = {
  device: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  coupon: PropTypes.object.isRequired,
  handleReceiveCoupon: PropTypes.func,
  handleReloadReceivedCoupon: PropTypes.func,
  isUsed: PropTypes.bool,
  isReceived: PropTypes.bool,
  isExpired: PropTypes.bool
};

PortalCouponListItem.defaultProps = {
  isUsed: false,
  isReceived: false,
  isExpired: false
};


// WEBPACK FOOTER //
// ./src/components/PortalCouponList/PortalCouponListItem.js